import * as React from 'react';
import {
  Box, Button, Grid, Tab, Typography,
} from '@material-ui/core';
import {
  TabList, TabContext,
} from '@material-ui/lab';
import { useSnackbar } from 'notistack';
import type { AxiosError } from 'axios';
import axios from 'axios';
import useSWR from 'swr';
import { Refresh } from '@material-ui/icons';
import type { IWorkView } from './WorkViewInterfaces';
import formatCurrentDateTime from '../../../lib/dateHelpers';
import WorkView from './WorkView';

const ViewWorkView: React.FC = () => {
  // Imports Initialization
  const { enqueueSnackbar } = useSnackbar();
  const formattedDate = formatCurrentDateTime();

  // State
  const [workViews, setWorkViews] = React.useState<IWorkView[]>(new Array<IWorkView>());
  const [workViewId, setWorkViewId] = React.useState<string>();
  const [triggerRefresh, setTriggerRefresh] = React.useState<boolean>(false); // The state will be passed to the child comp and trigger the useEffect that will refresh data.
  const [waitForFilterData, setWaitForFilterData] = React.useState<boolean>(false); // The state will be passed to the child comp and trigger the useEffect that will refresh data.

  const handleFetchWorkViews = (url: string) => {
    axios.get<IWorkView[]>(url)
      .then((response) => {
        setWorkViews(response.data);
        setWorkViewId(response.data[0].id);
      })
      .catch((err: AxiosError) => {
        if (err.response?.data === 'No Work Views found.') {
          enqueueSnackbar('No Work Views found.', { variant: 'error' });
        } else {
          enqueueSnackbar(`There was the following error when fetching the Work Views: ${JSON.stringify(err?.response?.data)}`, { persist: false, variant: 'error' });
        }
      });
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { data } = useSWR(
    ['/workView/getWorkViewsByUser'],
    (url) => handleFetchWorkViews(url),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateOnMount: true,
      refreshWhenOffline: false,
      refreshWhenHidden: false,
      refreshInterval: 0,
    },
  );

  const handleWorkViewTabChange = (event: unknown, newTabValue: string) => {
    if (!waitForFilterData) {
      setWorkViewId(newTabValue);
    }
  };

  // Render
  return (
    <>
      <Grid container>
        <Grid item lg={1} />
        <Grid item lg={9} md={12} xs={12}>
          <Grid container justifyContent="space-between">
            <Grid item xs={8}>
              <Box>
                <Typography variant="h5" color="primary">
                  {'Your Work Views'}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Box display="inline" mx={1}>
                <Button
                  variant="text"
                  onClick={() => { setTriggerRefresh(!triggerRefresh); }}
                  style={{
                    color: '#959595', fontStyle: 'italic', textTransform: 'capitalize', float: 'right', fontSize: '12px', lineHeight: '14px',
                  }}
                >
                  <Refresh style={{ paddingRight: '8px', fill: '#959595' }} />
                  {'Totals updated '}
                  {formattedDate}
                </Button>
              </Box>
            </Grid>
          </Grid>

          <TabContext value={workViewId || ''}>
            <Box>
              <TabList
                variant="scrollable"
                scrollButtons="auto"
                indicatorColor="primary"
                onChange={handleWorkViewTabChange}
              >
                {workViews.map((workView) => (
                  <Tab label={workView?.name} value={workView.id} />
                ))}
              </TabList>
            </Box>
            {workViewId ? (
              <WorkView
                workViewId={workViewId}
                refreshWorkView={triggerRefresh}
                waitForFilterData={waitForFilterData}
                setWaitForFilterData={setWaitForFilterData}
              />
            ) : (
              <Box width="100%" height="56px" />
            )}
          </TabContext>
        </Grid>
      </Grid>
      <br />
      <br />
      <br />
      <br />
    </>
  );
};

export default ViewWorkView;
